/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollTrigger,SplitText);
import imagesLoaded from 'imagesloaded';
import { mobileNav } from './modules/mobileNav';
import { newsSlider } from './modules/newsSlider.js';
import { principlesSlider } from './modules/principlesSlider.js';
import { messagesSlider } from './modules/messagesSlider.js';
import { faqs } from './modules/faqs.js';
import { heroSlider } from './modules/heroSlider.js';

// Cursor stuff
// import Cursor from "./modules/cursor";
// import Magnetic from "./modules/magnetic";

var faqsExist = document.querySelector('.faqs');
  if (faqsExist) {
    faqs();
  }

imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
  // Load stuff after all the images in the body load
  var principlesSliderExists = document.querySelector('.principles__slider');
  if (principlesSliderExists) {
    principlesSlider();
  }

  var newsSliderExists = document.querySelector('.news__feed');
  if (newsSliderExists) {
    newsSlider();
  }

  var messagesSliderExists = document.querySelector('.info__messagesSlider');
  if (messagesSliderExists) {
    messagesSlider();
  }

  var heroSliderExists = document.querySelector('.stateHero__slider');
  if (heroSliderExists) {
    heroSlider();
  }
});

// Animate On Scroll
import { animateOnScroll } from './modules/animateOnScroll.js';
animateOnScroll();


// Don't load on mobile
function is_touch_enabled() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Mobile vs. Desktop controls
if( ! is_touch_enabled() ) {

} else {
  $('body').addClass('touch');
  mobileNav();
}

import { contactForm } from './modules/contactForm';
contactForm();

const titles = document.querySelectorAll(".splitText");

function setupSplits() {
  titles.forEach(title => {
    // Reset if needed
    if(title.anim) {
      title.anim.progress(1).kill();
      title.split.revert();
    }

    title.split = new SplitText(title, {
      type: "lines,words",
      linesClass: "split-line"
    });

    // Set up the anim
    title.anim = gsap.from(title.split.words, {
      scrollTrigger: {
        trigger: title,
        toggleActions: "restart pause resume reverse",
        start: "top 50%",
      },
      duration: 0.5,
      ease: "circ.out",
      y: 100,
      stagger: 0.05,
    });

    // $('.hero__title').addClass('animated');
  });

  setTimeout(() => {
    $('.hero__title').addClass('animated');
  }, 500);
}

ScrollTrigger.addEventListener("refresh", setupSplits);
setTimeout(() => {
  $('.splitText').addClass('ready');
  setupSplits();
}, 500);
setTimeout(() => {
  $('.siteHeader').addClass('load');
}, 750);

// Refire stuff on window resize
var timeout = false, // holder for timeout id
    delay   = 250; // delay after event is "complete" to run callback

// window.resize event listener
window.addEventListener('resize', function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(function () {
    ScrollTrigger.refresh();
  }, delay);
});

// $('.info__nextMessage').on('click tap', function() {
//   $(this).closest('.info__message').hide();
//   var targetMessage = $(this).attr('data-message-id');
//   // alert(targetMessage);
//   $('#' + targetMessage).show();
// });

$('.info__nav .button').on('click tap', function(e) {
  e.preventDefault();
  var target = $(this).attr('data-target-id');

  $('.info__nav .button').removeClass('active');
  $(this).addClass('active');
  // alert(target);

  $('.info__content').hide();
  $('.info__content#' + target).show();

  if (target === 'leaders') {
    $('.info__messages').addClass('red');
    $('.info__nav .button[data-target-id=message').addClass('outline');
  } else {
    $('.info__messages').removeClass('red');
  }

  $('html, body').scrollTop($(".info__messages").offset().top - 150);

});
